<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <el-form ref="firstForm" :model="firstForm" label-width="100px" style="width: 500px;">
        <el-form-item label="名称">
          {{ firstForm.whiteListName }}
        </el-form-item>
                <el-form-item label="限制站点">
          <el-radio-group v-model="firstForm.isAll" disabled>
            <el-radio :label="'1'"> 选择运营商</el-radio>
            <el-radio :label="'2'">选择电站</el-radio>
          </el-radio-group>
        </el-form-item>
 <el-form-item v-if="firstForm.isAll=='1'" label="" >
          <!-- <STree v-model="firstForm.limiteSite" :data="stationTree" style="width:400px;"></STree> -->
           <GoodStree
            :data="stationData1"
            style="width:400px;"
            v-model="firstForm.limiteSite"
          />
        </el-form-item>
        <el-form-item v-if="firstForm.isAll=='2'" label="">
          <!-- <STree v-model="firstForm.limiteSite" :data="stationTree" style="width:400px;"></STree> -->
          <GoodStree
            :data="stationTree"
            style="width:400px;"
             v-model="firstForm.limiteSite"
          />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">限制规则</span>
      </div>
      <el-form ref="secondForm" :model="secondForm" label-width="100px" style="width: 500px">
        <el-form-item label="限制时间">
          {{ secondForm.limiteStartDay }}&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;{{ secondForm.limiteEndDay }}
        </el-form-item>
        <!-- </el-row> -->
        <el-form-item label="限制周天">
          <div v-if="hasWeek">
            <el-tag v-for="(item, index) in secondForm.week" :key="index" style="margin-left: 20px;">{{ item }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="每日时段">
          {{ secondForm.limiteStartHour }}&nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;&nbsp;{{ secondForm.limiteEndHour }}
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">限制机构</span>
      </div>
      <el-form ref="lastForm" :model="lastForm" label-width="100px" style="width: 500px">
          <el-form-item label="限制用户" prop="userType">
            <el-radio-group v-model="lastForm.userType" disabled>
              <el-radio
                v-for="(item, index) in userTypeItem"
                :key="index"
                :label="item.id"
              >{{ item.label }}</el-radio>
            </el-radio-group>
           <el-input  v-show="lastForm.userType === '3'" type="textarea" v-model="lastForm.desc"></el-input>

            <!-- 选择企业 -->
            <div v-show="lastForm.userType === '1'" class="border">
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="lastForm.mechanism"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="lastForm.userType === '2'" class="border">
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="lastForm.tag"
              />
            </div>
          </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { treeDisabled } from '@/utils/tool'
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Baimingdanxiangqing',
  components: {},
  data() {
    return {
         userTypeItem: [
        {
          label: "选择企业",
          id: "1"
        },
        {
          label: "选择标签",
          id: "2"
        },
           {
          label: "输入单用户",
          id: "3"
        },
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      treeDefaultProps: {
        children: "children",
        label: "name"
      },
      firstForm: {
        isAll:'1'
      },
      stationTree: [],
      personTree: [],
      secondForm: {
        week: []
      },
      lastForm: {
        userType: "2", // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [],
        desc:'' // 选择标签
      },
      id: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      defaultArr: [],
      hasWeek: false
    }
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  mounted() {
    this.getStationTree()
    this.getUserTree()
    this.getDetail()
            this.getTagTree();
    this.getMechanismTree();
         this.getOperator()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
           filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch("form/handle", {
        url: "/user/label/all",
        data: { orgType: "1,3", labelType: "0" },
        callback: resp => {
           this.tagTreeData = treeDisabled(resp, true)
        }
      });
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch("form/handle", {
        url: "/setting/tree/org",
        data: { orgType: "1,3" },
        callback: resp => {
        this.mechanismTreeData = treeDisabled(resp, true)
        }
      });
    },
    partakeCancelTree() {
      this.$refs.treeMechanism.setCheckedKeys([]);
      this.$refs.treeTag.setCheckedKeys([]);
    },
    // 选择企业 赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.lastForm.mechanism = this.$refs.treeMechanism.getCheckedKeys();
    },
    // 选择标签 赋值
    handleTagChange(data, checked, indeterminate) {
      this.lastForm.tag = this.$refs.treeTag.getCheckedKeys();
    },
    cancel() {
      this.$router.go(-1)
    },

    getDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/business/whitelist/detail',
        data: data,
        method: 'get',
        callback: resp => {
                     this.firstForm.isAll = resp.siteType
          const arr = resp.limiteWeek.split(',')
          arr.sort(function(a, b) { return a - b })
          if (arr[arr.length - 1] === '7') {
            arr.unshift(arr[arr.length - 1])
            arr.pop(arr[arr.length - 1])
          }
          if (resp.limiteWeek != '' || arr.length > 1) {
            this.hasWeek = true
            if (arr[0] == '') {
              arr.splice(0, 1)
            }
            for (let i = 0; i < arr.length; i++) {
              if (arr[i] === '1') {
                arr[i] = '周一'
              } else if (arr[i] === '2') {
                arr[i] = '周二'
              } else if (arr[i] === '3') {
                arr[i] = '周三'
              } else if (arr[i] === '4') {
                arr[i] = '周四'
              } else if (arr[i] === '5') {
                arr[i] = '周五'
              } else if (arr[i] === '6') {
                arr[i] = '周六'
              } else if (arr[i] === '7') {
                arr[i] = '周日'
              }
            }
          } else {
            this.hasWeek = false
          }
          this.secondForm.week = arr
          this.firstForm.whiteListName = resp.whiteListName
          this.firstForm.limiteSite = resp.limiteSite ? resp.limiteSite.split(",") : []
          // if (resp.isAll) {
          //   for (var i = 0; i < this.stationTree.length; i++) {
          //     this.defaultArr.push(this.stationTree[i].id)
          //     for (var j = 0; j < this.stationTree[i].children.length; j++) {
          //       this.defaultArr.push(this.stationTree[i].children[j].id)
          //     }
          //   }
          // } else {
          //   if (!resp.limiteSite) {
          //     const arrId = []
          //     for (var i = 0; i < this.stationTree.length; i++) {
          //       arrId.push(this.stationTree[i].id)
          //     }
          //     this.firstForm.limiteSite = arrId
          //   } else {
          //     this.firstForm.limiteSite = resp.limiteSite.split(',')
          //   }
          // }




          // if (!resp.limiteSite) {
          //   const arrId = []
          //   for (var i = 0; i < this.stationTree.length; i++) {
          //     arrId.push(this.stationTree[i].id)
          //   }
          //   this.firstForm.limiteSite = arrId
          // } else {
          //   this.firstForm.limiteSite = resp.limiteSite.split(',')
          // }
          // if (resp.isAll) {
          //   for (var i = 0; i < this.stationTree.length; i++) {
          //     this.defaultArr.push(this.stationTree[i].id)
          //     for (var j = 0; j < this.stationTree[i].children.length; j++) {
          //       this.defaultArr.push(this.stationTree[i].children[j].id)
          //     }
          //   }
          // }
          console.log('ddddd', this.defaultArr)
          this.secondForm.limiteStartDay = resp.limiteStartDay
          this.secondForm.limiteEndDay = resp.limiteEndDay
          this.secondForm.limiteStartHour = resp.limiteStartHour
          this.secondForm.limiteEndHour = resp.limiteEndHour
          // this.lastForm.orgId = resp.orgId ? resp.orgId.split(',') : []
                    this.lastForm.userType=resp.userType
          if(resp.userType==1){
                     this.lastForm.mechanism = resp.orgId ? resp.orgId.split(',') : []
          }
          else if(resp.userType==2){
           this.lastForm.tag = resp.orgId ? resp.orgId.split(',') : []
          }
          else{
          this.lastForm.desc = resp.orgName ? resp.orgName : ''
          }
          if (resp.isAll == false) {
            this.isStation = true
          }
        }
      })
    },

    getStationTree() {
      this.$store.dispatch('form/handle', {
        url: '/business/whitelist/getStationList',
        method: 'get',
        callback: resp => {
          this.stationTree = resp
          for (var i = 0; i < this.stationTree.length; i++) {
            this.stationTree[i].disabled = true
            const tem = this.stationTree[i].children
            if (tem) {
              for (var j = 0; j < tem.length; j++) {
                tem[j].disabled = true
                const temp = tem.children
                if (temp) {
                  for (var k = 0; k < temp.length; k++) {
                    temp[k].disabled = true
                  }
                }
              }
            }
          }
        }
      })
    },
            getOperator() {
      const data = {
        attr: 0,
        orgTypes: "0,3",
        showOperatorName: true
      };
      this.$store.dispatch("form/handle", {
        url: "/business/discountterm/getResponsibleOrgTree",
        data: data,
        method: "get",
        callback: resp => {
          this.stationData1 = treeDisabled(resp,true);
        }
      });
    },
    getUserTree() {
      this.$store.dispatch('form/handle', {
        url: '/business/whitelist/getOrgAndUser',
        method: 'get',
        callback: resp => {
          this.personTree = resp
          for (var i = 0; i < this.personTree.length; i++) {
            this.personTree[i].disabled = true
            const tem = this.personTree[i].children
            if (tem) {
              for (var j = 0; j < tem.length; j++) {
                tem[j].disabled = true
                const temp = tem.children
                if (temp) {
                  for (var k = 0; k < temp.length; k++) {
                    temp[k].disabled = true
                  }
                }
              }
            }
          }
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.iconfont {
  width: 50px;
  height: 50px;
  margin: auto;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/whiteListDetail.vue